define('views/modules/member/select/member-select-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // models
    'collections/member/profiles',
    'collections/member/groups',
    //services
    'services/events/user-events',
    'services/i18n',
    // views
    'views/modules/member/select/member-select-list',
    'views/parts/form/textbox',
    'views/parts/menu/menu-dropdown',
    'views/parts/tree/tree-view',
    'views/parts/form/choices',
    'views/parts/menu/menu-action',
    'views/modules/member/group-panel',
    // templates
    'text!templates/modules/member/select/member-select-content.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // models & collections
    CProfiles,
    CGroups,
    //services
    UserEvents,
    i18n,
    // views
    VMemberSelectList,
    VTextBox,
    VMenuDropdown,
    VTreeView,
    VChoices,
    VMenuAction,
    VGroupPanel,
    // templates
    TMemberSelectContent
) {

    var VMemberSelectContent = Backbone.View.extend({

        template: TMemberSelectContent,

        regions: {
            root: ".member-select-content",
            menu: ".menu-actions",
            groups: ".group-tree",
            selectAll: ".select-all-input",
            search: ".search-input",
            list: ".member-list",
        },

        initialize: function(opt) {
            this.options = _.extend({
                confirmButtonText: i18n.t('template:confirm')
            }, opt);

            _.extend(this, {
                group: this.options.group,
                groupsCollection: new CGroups(null, { tree: true, tree_only: true, removeExpired: true }),
                collection: new CProfiles(),
                actionsCollection: new Backbone.Collection([
                    { id: 'btn-confirm', disabled: true, title: this.options.confirmButtonText, content: this.options.confirmButtonText, itemClass: 'btn-confirm pull-right', icon: 'fa fa-check', btnClass: 'btn-tc-custom', callback: this.onConfirm },
                ]),
            });

            var customActions = opt.customActions;
            if (customActions) {
                this.actionsCollection.add(_.isArray(customActions) ? customActions : customActions.models);
            }

            var groupTreeView = new VTreeView({
                label: 'name',
                subgroup: 'subgroups',
                activeAttribute: '_menuActive',
                depth: 5,
                toggleActive: true,
                firstOpen: true,
                collection: this.groupsCollection
            });

            var view = this.view = {
                menu: new VMenuAction({
                    context: this,
                    onClick: this.onActionClick,
                    collection: this.actionsCollection,
                    tooltip: {
                        container: this.regions.root
                    }
                }),
                groups: new VMenuDropdown({
                    context: this,
                    treeView: groupTreeView,
                    collection: new Backbone.Collection([
                        { id: 'showAll', icon: "sl-icon-people", label: "All Clients", callback: this.onShowAllClients },
                        { separator: true },
                        { tree: true, tree_only: true, view: groupTreeView }
                    ]),
                }),
                search: new VTextBox({ label: 'Search' }),
                selectAll: new VChoices({
                    label: "calendar:Select All",
                    onChange: this.onSelectAllChange,
                    context: this
                }),
                list: new VMemberSelectList({
                    collection: this.collection,
                })
            };

            this.listenTo(view.list, { 'selected:change': this.onMemberSelected })
                .listenTo(view.search, { 'submit': this.onQuerySubmit })
                .listenTo(groupTreeView, 'click', this.onSelectGroup)
                .listenTo(UserEvents, { 'group:manage': this.onDisplayGroupManager });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.search, zone.$search)
                .assign(view.groups, zone.$groups)
                .assign(view.menu, zone.$menu)
                .assign(view.selectAll, zone.$selectAll)
                .assign(view.list, zone.$list);

            this.reset();
            this.selectedGroup = undefined;

            this.groupsCollection.fetch();
            this.collection.getFirstPage({data: {limit: 500}});
        },

        setAllClientsLabel: function() {
            var view = this.view.groups;
            view.setLabel(view.getLabelById('showAll'));
            return this;
        },

        reset: function() {
            var collection = this.collection;
            if (this.group && !this.group.isSupervisor()) {
                collection.setSupervisors();
            }
            collection.resetGroup().resetQuery();
            this.resetSearch()
                .setConfirmButtonDisabled(true)
                .setAllClientsLabel()
                .resetSelectAll();
        },

        resetList: function() {
            //_.invoke(this.view.list, 'reset');
            this.collection.trigger('reset');
        },

        setConfirmButtonDisabled: function(value) {
            this.view.menu.findItem('btn-confirm').set('disabled', value);
            return this;
        },

        resetSearch: function() {
            this.view.search.setValue();
            return this;
        },

        resetSelectAll: function() {
            this.view.selectAll.setValue(false);
            return this;
        },

        ////////////
        // events //
        ////////////
        onDisplayGroupManager: function() {
            var grpPanel = new VGroupPanel();
            this.trigger('panel:stack', grpPanel);
        },

        onActionClick: function(e) {
            e.preventDefault();
        },

        onQuerySubmit: function(model, value) {
            this.collection.setQuery(value).getFirstPage();
            this.resetList();
        },

        onMemberSelected: function(selectedCollection) {
            this.setConfirmButtonDisabled(selectedCollection.length === 0);
        },

        onSelectGroup: function(groupModel) {
            var selectedGroup = this.selectedGroup,
                collection = this.collection;
            if (!selectedGroup || !selectedGroup.is(groupModel)) {
                collection.resetSupervisors();
                collection.setGroup(groupModel);
                collection.getFirstPage();
                selectedGroup = this.selectedGroup = groupModel;
            }
            this.view.groups.setLabel(selectedGroup.get('name'));
        },

        onConfirm: function() {
            var selected = this.view.list.getSelectedCollection();
            this.trigger('selected:confirm', selected);
            selected.reset();
        },

        // onReset: function(e) {
        //     this.collection
        //         .resetQuery()
        //         .getFirstPage();
        // },

        onShowAllClients: function() {
            var collection = this.collection;
            if (collection.getGroup()) {
                this.selectedGroup = undefined;
                collection.resetGroup();
                if (this.group && !this.group.isSupervisor()) {
                    collection.setSupervisors();
                }
                collection.fetch({data: {limit: 500}});
            }

            this.setAllClientsLabel();
        },

        onSelectAllChange: function(model, value) {
            _.invoke(this.view, value ? 'selectAll' : 'reset');
        }

    });

    return VMemberSelectContent;

});

